import styled from 'styled-components'

export const CenterWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 100%;
  & p {
    padding: 0.5rem;
  }
`

export const DashboardWrapper = styled.div`
  width: 100%;
  padding: ${(props) => (props.theme.isMobile ? '1rem' : '2rem')};
  padding-top: ${(props) => (props.theme.isMobile ? '4rem' : '')};
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.theme.isMobile ? 'center' : 'space-between')};
`

export const Title = styled.div`
  padding: 1rem 0;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.sizes.h1};
  font-weight: 700;
  & span {
    font-weight: 300;
  }
`

export const GraphCardWrapper = styled.div`
  height: 50%;
  min-height: ${(props) => (props.theme.isMobile ? '70%' : '50%')};
  background: ${(props) => props.theme.gradient.cardBackground};
  box-shadow: ${(props) => props.theme.shadow.main};
  border-radius: 6px;
  color: white;
`

export const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: ${(props) => (props.theme.isMobile ? '3rem 0' : '1rem 0')};
  justify-content: ${(props) => (props.theme.isMobile ? 'space-around' : 'start')};
  flex-wrap: wrap;
  column-gap: 1rem;
  padding-bottom: 1rem;
  gap: 1rem;
`

export const DateSelectorWrapper = styled.div`
  padding: 0 0 1rem 0;
  display: flex;
  flex: ${(props) => (props.theme.isMobile ? '1' : 'unset')};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`

export const PeriodSelectorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

export const DateSelectorButtonWrapper = styled.button<{ active: boolean; disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  border: none;
  padding: ${(props) => (props.theme.isMobile ? '0.5rem' : '0.5rem 1rem')};
  background-color: transparent;
  color: ${(props) =>
    props.disabled
      ? props.theme.colors.blackAlpha20
      : props.active
      ? props.theme.colors.primaryColor500
      : props.theme.colors.white};
  font-weight: ${(props) => (props.active ? 700 : 300)};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  &:hover {
    color: ${(props) => !props.disabled && props.theme.colors.primaryColor500};
  }
`

export const DocumentShortListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0;
  justify-content: start;
  column-gap: 1rem;
`

export const DatePickerWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding-left: 1rem;
  & > div {
    margin: 0;
    padding-right: 0 !important;
  }
  & input {
    width: 100%;
  }
  & .react-datepicker {
    right: ${(props) => (props.theme.isMobile ? '5rem !important' : '')};
  }
`

export const GraphWrapper = styled.div`
  display: flex;
  height: 100%;
  position: relative;
`

export const InnerGroupButton = styled.button<{ selected: boolean; borderRight?: boolean }>`
  outline: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.whiteAlpha40};
  border-right: ${(props) =>
    props.borderRight ? `1px solid ${props.theme.colors.whiteAlpha40}` : undefined};
  color: ${(props) =>
    props.selected ? props.theme.colors.primaryColor500 : props.theme.colors.white};
  &:hover {
    filter: ${(props) => (props.selected ? 'none' : 'brightness(1.2)')};
    color: ${(props) => props.theme.colors.primaryColor500};
  }
`
export const GroupButton = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  padding: 1rem;
`

export const CustomInput = styled.input`
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.colors.whiteAlpha40};
  border-radius: 4px;
  padding: 0.3rem;
  color: ${(props) => props.theme.colors.white};
  &:focus {
    outline: none;
  }
`
